import { render, staticRenderFns } from "./createFranchiseDoctor.vue?vue&type=template&id=1b743662&scoped=true&"
import script from "./createFranchiseDoctor.vue?vue&type=script&lang=js&"
export * from "./createFranchiseDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b743662",
  null
  
)

export default component.exports